<template>
    <div v-if="value.meta">
      <el-divider />
        <h3>Additional Details</h3>
      <el-row :gutter="60">
        <!-- Are you vaccinated? -->
        <!-- <el-col :span="24" :md="8" class="mt-20">
          <el-input-title required>School</el-input-title>
          <el-form-item prop="meta.volunteer">
            <el-input class="mt-05" v-model="value.meta.school" placeholder="School" />
          </el-form-item>
        </el-col> -->
        <el-col :span="24" :md="12" class="mt-20">
          <el-input-title required>What UTAS member type are you?</el-input-title>
          <el-form-item prop="meta.utasMemberType">
            <el-select class="mt-05" v-model="value.meta.utasMemberType" placeholder="Select a member type">
              <el-option v-for="e in utasMemberTypes" :label="e.name" :key="e.type" :value="e.type" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- Student ID if Student, Staff ID if Staff Member -->
        <el-col :span="24" :md="12" class="mt-20" v-if="['staff','student'].includes(value.meta.utasMemberType)">
        <el-input-title required>Please specify your {{ selectedMemberType }}</el-input-title>
        <el-form-item prop="meta.utasId">
          <el-input
            class="mt-05"
            v-model="value.meta.utasId"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-col>
      </el-row>
    </div>
  </template>
<script>
import playerDetails from '@/mixins/player-details';

export default {
  name: 'utasExtra',
  mixins: [playerDetails],
  props: ['value', 'refs'],
  data() {
    return {
      utasMemberTypes: [
        {
          name: 'Student',
          type: 'student',
        },
        {
          name: 'Staff Member',
          type: 'staff',
        },
        {
          name: 'Member of community',
          type: 'community'
        }
      ],
    };
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    selectedMemberType() {
      const { meta } = this.value;
      return meta && meta.utasMemberType === 'student' ? 'Student ID' : 'Staff ID';
    }
  }
};
</script>

  <style lang="scss" scoped>

  .el-autocomplete,
  .el-select,
  .el-input {
    width: 100%;
  }

  </style>
